// Colorscales for the generated fields, keyed by the `colorscale` id each
// parameter carries in GET /v1/catalog. Stops use the viewer's format:
// [position 0..1, [r, g, b]] (see colorscale.js).

export const COLORSCALES = {
  temperature: { stops: [[0, [49, 54, 149]], [0.25, [69, 117, 180]], [0.45, [171, 217, 233]], [0.55, [254, 224, 144]], [0.75, [244, 109, 67]], [1, [165, 0, 38]]] },
  humidity: { stops: [[0, [140, 81, 10]], [0.5, [246, 232, 195]], [1, [1, 102, 94]]] },
  diverging: { stops: [[0, [33, 102, 172]], [0.5, [247, 247, 247]], [1, [178, 24, 43]]] },
  wind: { stops: [[0, [30, 40, 80]], [0.15, [40, 110, 190]], [0.3, [60, 190, 170]], [0.5, [240, 220, 60]], [0.7, [240, 120, 40]], [0.85, [210, 30, 60]], [1, [140, 20, 160]]] },
  visibility: { stops: [[0, [120, 70, 30]], [0.15, [190, 140, 80]], [0.5, [200, 200, 190]], [1, [20, 30, 40]]] },
  pressure: { stops: [[0, [120, 0, 120]], [0.4, [60, 80, 200]], [0.75, [200, 220, 240]], [1, [250, 250, 250]]] },
  precip: { stops: [[0, [110, 190, 110]], [0.05, [120, 200, 120]], [0.25, [40, 160, 60]], [0.45, [250, 230, 40]], [0.7, [240, 100, 30]], [1, [200, 0, 160]]] },
  cloud: { stops: [[0, [20, 30, 40]], [1, [235, 240, 245]]] },
  cape: { stops: [[0, [50, 80, 150]], [0.3, [70, 120, 200]], [0.6, [250, 200, 50]], [1, [220, 30, 30]]] },
  surge: { stops: [[0, [30, 90, 170]], [0.3, [30, 120, 200]], [0.7, [120, 220, 240]], [1, [255, 255, 255]]] },
  ejecta: { stops: [[0, [110, 65, 35]], [0.4, [140, 80, 40]], [0.8, [230, 150, 60]], [1, [255, 240, 200]]] },
  ash: { stops: [[0, [95, 95, 95]], [0.5, [120, 120, 120]], [1, [240, 240, 235]]] },
  smoke: { stops: [[0, [115, 100, 85]], [0.4, [150, 120, 90]], [0.8, [220, 200, 170]], [1, [255, 250, 240]]] },
  fire: { stops: [[0, [130, 15, 0]], [0.3, [180, 20, 0]], [0.6, [255, 120, 0]], [0.85, [255, 220, 60]], [1, [255, 255, 220]]] },
};

/** Fields that read "nothing here" at their low end and should fade out
 * there instead of painting the whole box. */
export const FADE_LOW = new Set(["precip", "surge", "ejecta", "ash", "smoke", "fire", "cape"]);
/** Visibility fades at its HIGH end (clear air). */
export const FADE_HIGH = new Set(["visibility"]);

export const MARKER = {
  meteor: { color: "#ff7a45", glyph: "☄" },
  hurricane: { color: "#4ea8ff", glyph: "🌀" },
  volcano: { color: "#e5484d", glyph: "🌋" },
  wildfire: { color: "#ffb224", glyph: "🔥" },
};
